var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"startFinishConfig"},[_c('StartFinishConfigDisplay',{attrs:{"installation-id":_vm.installationId,"lane-number":_vm.laneNumber}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }